import { render } from "./IconCross2.vue?vue&type=template&id=80930a56"
import script from "./IconCross2.vue?vue&type=script&lang=js"
export * from "./IconCross2.vue?vue&type=script&lang=js"
script.render = render

export default script